<template>
  <el-dialog
    title="设备地址编辑"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="70px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="地区" size="small">
        <el-cascader
          style="width: 100%"
          size="small"
          class="long"
          :props="{ checkStrictly: true }"
          :options="regionData"
          v-model="model.area"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="地址" size="small" prop="detail">
        <el-input
          size="small"
          v-model="model.detail"
          placeholder="请输入详细地址（省市区请在上面地区栏选择）"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { regionData } from '@/util/area_tool'
import {
  createCustomerDeviceAddress,
  updateCustomerDeviceAddress,
} from '../service/getData'
import { clone } from '../util'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      regionData,
      visible: this.show,
      formRules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 10 个字符',
            trigger: 'blur',
          },
        ],
      },
      submiting: false,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = clone(this.model)
          let area = data.area
          data.province = area[0] || ''
          data.city = area[1] || ''
          data.county = area[2] || ''

          this.submiting = true
          if (this.model.id > 0) {
            let res = await updateCustomerDeviceAddress(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCustomerDeviceAddress(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
        }
      })
    },
  },
}
</script>